import Vue from 'vue'
import Vuex from 'vuex'
import { listSubject } from '@/api/daily';
import { getUserAllInfo } from '@/api/app';
Vue.use(Vuex);
const store = {
    state: {
        routerState: '/',
        httploading: false,
        userInfo: {},
        appParameter: {},
        order: '',
        routeQuery: '',
        payParams: '',
        dailog:"",
		dailyList:[],
		dailyChosen: [],
        examQaState:null
    },
    mutations: {
        routerChange(state, value) {
            state.routerState = value;
        },
        changeLoading(state, value = false) {
            state.httploading = value
        },
        setappParam(state, value) {
            state.appParameter = value;
        },
        setUserInfo(state, value) {
			let temp = JSON.parse(JSON.stringify(state.userInfo));
            Object.keys(value).forEach(key=>{
                temp[key] = value[key];
			})
			state.userInfo = temp;
        },
        saveOrderData(state, value) {
            state.order = value;
        },
        setRouteQuery(state, value) {
            state.routeQuery = value;
        },
        setPayMsg(state, value) {
            state.payParams = value;
        },
        changeDailog(state,value){
            state.dailog=value
		},
		setDailyList(state,value){
			let temp = JSON.parse(JSON.stringify(state.dailyList));
            Object.keys(value).forEach(key=>{
                temp[key] = value[key];
			})
			state.dailyList = temp;
		},
		setDailyChosen(state,value){
			state.dailyChosen = value;
		},
		updateDailyUserState(state,value){
			state.dailyList.userState = value;
		},
        setExamQaState(state,value){
            state.examQaState = value
        }
    },
    actions: {
		fliterDaily({commit},value){
			return new Promise((resolve,reject)=>{
				listSubject(value).then(result=>{
					if(result.code == 200){
						let { finishSubjectNum,all,chosen, userState } = result.data;
						commit('setDailyList',{ all: value == 69 ? [] : all, finishSubjectNum, userState });
						commit('setDailyChosen',chosen);
						resolve(result);
					}else{
						reject(result)
					}
				}).catch(e=>{
					reject(e)
				})
			})
		},
		userInfo({commit}){
			return new Promise((resolve, reject) => {
                getUserAllInfo()
                .then(result=>{
                    if(result.code==200){
                        commit('setUserInfo',result.data);
                        resolve();
                    } else {
                        reject();
                    }
                })
            })
		},
    },
}

export function createStore() {
    return new Vuex.Store(store);
}



// WEBPACK FOOTER //
// ./src/store/index.js